
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Nav from './components/navbar/nav';
import ScrollToTop from './components/navbar/scrollToTop';
import Home from './components/home/home';
import Club from './components/club/club';
import Infoscription from './components/infoscription/infoscription';
import Registration from './components/infoscription/registration';
import RegistrationHelp from "./components/infoscription/registrationHelp"
import Beach from './components/beach/beach'

import Events from './components/events/events';
import EventsDetails from './components/events/eventsDetails'
// import EventSelectedDetails from './components/events/eventSelectedDetails'

import Footer from './components/footer/footer';
import Partners from './components/partners/partners';
import SignIn from "./components/administrator/signIn";
import ProtectedRoute from "./components/auth/protectedRoute";
import BackOfficeMainPage from './components/backOffice/backOfficeMainPage';
import Contact from './components/contact/contact';


function App() {


  return (
    <Router>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route element={<Home />} path="/" exact />
        <Route element={<Club />} path="/club" exact />
        <Route element={<Infoscription />} path="/infoscription" exact />
        <Route element={<Registration/>} path="/registration" exact />
        <Route element={<RegistrationHelp/>} path="/registrationHelp" exact />
        <Route element={<Beach />} path="/beach" exact />

        <Route element={<Events />} path="/events" exact />
        <Route element={<EventsDetails />} path="/eventsDetails" exact />

        <Route element={<Partners />} path="/partners" exact />
        {/* ESPACE MEMBRES : connexion unique, back office réservé aux membres connectés */}
        <Route element={<SignIn />} path="/signIn" exact />
        <Route element={<Navigate to="/signIn" replace />} path="/signInContributor" exact />
        <Route element={<Navigate to="/signIn" replace />} path="/signInAdministrator" exact />
        <Route element={<ProtectedRoute><BackOfficeMainPage /></ProtectedRoute>} path="/backofficemainpage" exact />
        <Route element={<Navigate to="/backofficemainpage" replace />} path="/administrator" exact />
        <Route element={<Contact />} path="/contact" exact />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
